import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { format } from 'date-fns';
import SmartImage from './SmartImage';

interface UniversalCardProps {
  post: {
    id: string;
    title: string;
    excerpt: string;
    category: string;
    publishedAt: Date;
    featuredImage?: string;
  };
  className?: string;
}

const formatDate = (date: Date): string => {
  return format(date, 'MMMM d, yyyy');
};

export const UniversalCard: React.FC<UniversalCardProps> = ({ post, className = '' }) => {
  return (
    <article className={`nb-universal-card ${className}`}>
      <div className="nb-universal-card-image">
        <Link to={`/post/${post.id}`}>
          <SmartImage 
            src={post.featuredImage} 
            alt={post.title}
            width={400}
            aspectRatio="landscape"
            className="nb-universal-card-img"
          />
        </Link>
      </div>
      <div className="nb-universal-card-content">
        <div className="nb-universal-card-meta">
          <div className="nb-meta-item">
            <Calendar size={14} />
            <span>{formatDate(post.publishedAt)}</span>
          </div>
        </div>
        <h2 className="nb-universal-card-title">
          <Link to={`/post/${post.id}`}>{post.title}</Link>
        </h2>
        <p className="nb-universal-card-excerpt">{post.excerpt}</p>
        {post.category && (
          <div className="nb-card-category">{post.category}</div>
        )}
        {/* Read more removed for minimal design */}
      </div>
    </article>
  );
};

export default UniversalCard;
